import { PayPalButtons, PayPalScriptProvider } from "@paypal/react-paypal-js";
import React, { useEffect, useRef, useState } from "react";
import { env } from "@/env.mjs";
import { useToast } from "@/components/ui/use-toast";
import { v4 as uuidv4 } from "uuid";
import /*getUserSkills,
	initiateSkillCategory,
	makeSkillCategoryPriority,
	updateSkillCategoryAwards,
	updateSkillCategoryCertification,
	updateSkillCategoryEducation,*/
"@/lib/api/api";
// import { getUser, isAdmin } from "@/lib/api/authentication";
// import { getSkillCSV } from "../../api/storage";

// import { useAuthContext } from "../../providers/auth_provider";

// import PayPal from "../paypal";
import { Categories } from "./category";
import { AboutForm } from "./form/about";
import { AwardForm } from "./form/award";
import { CertificatesForm } from "./form/certificates";
import { EducationForm } from "./form/education";
import { About } from "./view/about";
import { Award } from "./view/award";
import { Certificates } from "./view/certificates";
import { EditEducation } from "./view/edit";
import { Education } from "./view/education";
import { Button } from "../ui/button";
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
	DialogTrigger,
} from "@/components/ui/dialog";
import { Card, CardContent } from "../ui/card";
import {
	PlusCircledIcon,
	Pencil1Icon,
	ChevronUpIcon,
	CrossCircledIcon,
} from "@radix-ui/react-icons";
import {
	getUserInfo,
	isAdmin,
	isMember,
} from "@/lib/api/client-authentication";
import PayPal from "../paypal";
import { usePathname } from "next/navigation";
import {
	Tooltip,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger,
} from "../ui/tooltip";
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	AlertDialogTrigger,
} from "../ui/alert-dialog";

// function PayPalScriptProvider({ children, ...props }: any) {
// 	return (<> <div>
// 		<h3>PayPalProvider</h3>
// 		{children}
// 	</div></>)
// }

// let appConfig = {
// 	paypalClientId: ""
// }

// async function getUserSkills(...args: any[]) {
// 	let mockJson = JSON.parse(`[ {
// 		"id": "123456",
// 		"name": "Programming",
// 		"categories": ["Software Development", "Web Development"],
// 		"awards": ["Best Developer 2022"],
// 		"about": {
// 			"about": "I am a skilled software developer with 5+ years of experience...",
// 			"currency_code": "USD",
// 			"hour": 40,
// 			"halfAnHour": 20
// 		},
// 		"education": [
// 			{
// 				"startDate": "2016-09-01",
// 				"institution": "MIT",
// 				"fieldOfStudy": "Computer Science",
// 				"endDate": "2020-06-30",
// 				"degree": "Bachelor of Science"
// 			}
// 		],
// 		"certification": [
// 			{
// 				"credentialID": "CRED001",
// 				"endDate": "2022-12-31",
// 				"dateIssued": "2022-01-01",
// 				"institution": "Microsoft",
// 				"name": "Microsoft Certified: Azure Developer Associate"
// 			}
// 		]
// 	}]`)

// 	return mockJson

// }
// async function initiateSkillCategory(...args: any[]) {

// }

// async function makeSkillCategoryPriority(...args: any[]) {

// }

// async function updateSkillCategoryAwards(...args: any[]) {

// }

// async function updateSkillCategoryCertification(...args: any[]) {
// 	let s: any[] = []
// 	return s
// }

// async function updateSkillCategoryEducation(...args: any[]) {
// 	let s: any[] = []
// 	return s;
// }

// async function getSkillCSV(...args: any[]) {
// 	return "array"
// }

type SkillObj = {
	id: string;
	name?: string;
	certification?: CertificationObj[];
	categories?: string[];
	education?: EducationObj[];
	awards?: any[];
	about?: AboutObj;
};

type AboutObj = {
	about: string;
	currency_code: string;
	hour: string;
	halfAnHour: string;
};

type EducationObj = {
	institution: string;
	degree: string;
	fieldOfStudy: string;
	startDate: string;
	endDate: string;
};

type CertificationObj = {
	name: string;
	institution: string;
	dateIssued: string;
	endDate: string;
	credentialID: string;
	credentialUrl: string;
};

type Props = {
	userId: string;
	tier: string;
	isMember: boolean;
	isAdmin: boolean;
};

export const SkillCategories = ({ userId, tier, isMember, isAdmin }: Props) => {
	const [disable, setDisable] = useState(true);
	const [skills, setSkills] = useState<SkillObj[]>([]);
	const [skillList, setSkillList] = useState<any[]>([]);
	const [currentSkill, setCurrentSkill] = useState<SkillObj>({
		id: uuidv4(),
		name: "",
		about: {
			about: "",
			currency_code: "",
			hour: "",
			halfAnHour: "",
		},
		awards: [],
		categories: [],
		education: [],
		certification: [],
	});
	const [editSkillNameMode, setEditSkillNameMode] = useState(false);
	const [showModal, setShowModal] = useState(false);
	const [limitMessage, setLimitMessage] = useState("");
	const [country, setCountry] = useState<string>(""); //user location from the user item
	const toggleModal = (): void => setShowModal(!showModal);
	let content: any;
	const { toast } = useToast();
	const pathname = usePathname();

	useEffect(() => {
		const getSkills = async () => {
			const res = await fetch(`/api/user/skills?id=${userId}`);
			const userSkills = await res.json();
			setSkills(userSkills);
			if (userSkills?.length > 0) {
				setCurrentSkill(userSkills[0]);
			}
		};
		const loadUserCountry = async () => {
			const res = await fetch(`/api/user/profile?id=${userId}&area=profile`);
			const profile = await res.json();
			setCountry(profile?.country);
		};

		getSkills();
		loadUserCountry();
	}, [userId]);

	useEffect(() => {
		const loadSkills = async () => {
			if (isAdmin || isMember) {
				const res = await fetch("/api/user/skills/csv");

				const skills = await res.text();
				// const skills = "Abbey\\nAboriginal and Torres Strait Islander Organisation\\nAboriginal Art Gallery\\nAbrasives Supplier\\nAbundant Life Church\\nAccountant\\nAccounting Firm\\nAccounting School\\nAccounting Software Company\\nAcoustical Consultant\\nAcrobatic Diving Pool\\nAcrylic Store\\nAcupuncture Clinic\\nAcupuncture School\\nAcupuncturist\\nAcura Dealer\\nAddiction Treatment Center\\nAdministrative Attorney\\nAdoption Agency\\nAdult Day Care Center\\nAdult Education School"
				console.log("Original Skills", skills);

				//console.log("Skills from response csv ", skills)
				//NB There is a constant below that uses the same regex to filter the split list
				//categoriesList
				const skillsList = skills.split(/(\\r\\n|"|\n|\\n)+/);
				setSkillList({ ...skillsList });
				setDisable(false);
			} else {
				setDisable(true);
			}
		};
		loadSkills();
	}, []);

	const handleAddSkill = async () => {
		console.log("Handle Skill Called !!");
		if (tier === "Teacher") {
			//BUG Modified code Should be >=1
			if (skills.length >= 1) {
				setLimitMessage(
					"You can increase your limit by upgrading to Skills Teacher Plus"
				);
				setShowModal(true);
				console.log("In Handle Skill teir Teacher ");
				return;
			}
		} else if (tier === "TeacherPlus") {
			if (skills.length >= 5) {
				setLimitMessage("");
				setShowModal(true);
				return;
			}
		}

		setEditSkillNameMode(true);
		const newSkill = {
			id: uuidv4(),
			name: "",
			awards: [],
			categories: [],
			education: [],
			certification: [],
		};
		setSkills([...skills, newSkill]);
		setCurrentSkill(newSkill);
	};

	// const categoriesList = Object.entries(skillList).map(([key, value]) => {

	// 	return {
	// 		label: value,
	// 		value: value,
	// 	};
	// });

	const categoriesList = Object.entries(skillList).reduce(
		(acc: { label: string; value: string }[], [key, value]) => {
			if (!/(\\r\\n|"|\n|\\n)+/g.test(value) && value !== "") {
				acc.push({
					label: value,
					value: value,
				});
			}
			return acc;
		},
		[]
	);

	console.log("CATEGORY LIST DISPLAY ", categoriesList);
	const handleDoubleClick = async () => {
		if (!disable) {
			setEditSkillNameMode(true);
		}
	};

	const handleEditSkillName = async (e: any) => {
		console.log(
			"Handle handleEditSkillName Skill Called with value",
			e.target.value
		);
		const updatedSkills = skills.map((skill: any) => {
			if (skill.id === currentSkill.id) {
				return {
					...skill,
					name: e.target.value,
				};
			} else {
				return skill;
			}
		});
		const toastId = toast({
			title: "Creating category...",
		});

		let result;
		try {
			let res = await fetch(`/api/user/skills/category`, {
				method: "POST",
				body: JSON.stringify({
					userId,
					category: e.target.value,
					currentSkillId: currentSkill.id,
					country,
				}),
			});
			result = await res.json();
			console.log("Result from skill Initiation", result);
			toastId.update(
				toast({
					title: "Success",
					variant: "default",
				})
			);
		} catch (e) {
			toastId.update(
				toast({
					title: "Creating category Failed",
					variant: "destructive",
				})
			);
		}

		// toast.promise(result, {
		// 	pending: {
		// 		render() {
		// 			return "Creating category...";
		// 		},
		// 		icon: false,
		// 	},
		// 	success: {
		// 		render({ data }) {
		// 			return `Success`;
		// 		},
		// 		// other options
		// 		icon: "🟢",
		// 	},
		// 	error: {
		// 		render({ data }) {
		// 			// When the promise reject, data will contains the error
		// 		},
		// 	},
		// });
		setCurrentSkill({ ...currentSkill, name: e.target.value });
		setSkills(updatedSkills);
		setEditSkillNameMode(false);
	};

	const handleOnBlur = () => {
		setEditSkillNameMode(true);
	};

	const handleDeleteSkill = async (selectedId: string) => {
		const updatedSkills = skills.filter(
			(skill: any) => skill.id !== selectedId
		);
		const toastId = toast({
			title: "Deleting category...",
		});

		let result;
		try {
			let res = await fetch(`/api/user/skills/category?id=${selectedId}`, {
				method: "DELETE",
			});
			result = await res.json();
			console.log("Result from skill delete", result);
			toastId.update(
				toast({
					title: "Success",
					variant: "default",
				})
			);
		} catch (e) {
			toastId.update(
				toast({
					title: "Deleting category Failed",
					variant: "destructive",
				})
			);
		}
		setSkills(updatedSkills);
		setCurrentSkill({});
	};

	const createSkills = () => {
		const buttonSkillActive = `
		block
		min-w-[100px]
		min-h-[30px]
		mx-1
		px-2
		py-1
		rounded-full
		bg-rose-600
		text-white
		tracking-wide
		text-xs
		transition-all
		duration-300
		border-none`;

		const buttonSkill = `block
		min-w-[100px]
		min-h-[30px]
		mx-1
		px-2
		py-1
		border-2
		border-rose-600
		rounded-full
		bg-transparent
		text-black
		tracking-wide
		text-xs
		transition-all
		duration-300`;

		const allSkills = skills.map((skill: any, index) => {
			return (
				<li key={skill.id} className="relative mb-px mr-1">
					{editSkillNameMode &&
					currentSkill.id === skill.id &&
					!disable ? (
						<select
							onChange={handleEditSkillName}
							onBlur={handleOnBlur}
							value={skill.name}
							className=" w-72 sm:w-auto block px-3 py-2 bg-white rounded text-sm border border-gray-200 focus:border-gray-300 focus:ring focus:ring-gray-100 focus:ring-opacity-50">
							<option value="" disabled selected>
								Select a new Skill
							</option>
							{categoriesList.map((option, index) => (
								<option key={index} value={option.value}>
									{option.label}
								</option>
							))}
						</select>
					) : (
						<TooltipProvider>
							<Tooltip>
								<TooltipTrigger asChild>
									<button
										className={`inline-flex px-3 py-2 text-sm leading-none border rounded   hover:border-transparent  hover:bg-teal-500 ${
											currentSkill.name === skill.name
												? buttonSkillActive
												: buttonSkill
										}`}
										onClick={() => handleSelectSkill(skill)}
										onDoubleClick={() => handleDoubleClick()}>
										{skill.name}
										{!disable && (
											<AlertDialog>
												<AlertDialogTrigger>
													<span>
														<CrossCircledIcon
															height={undefined}
															width={undefined}
															className="h-4 sm:h-3 ml-1 cursor-pointer"
														/>
													</span>
												</AlertDialogTrigger>
												<AlertDialogContent>
													<AlertDialogHeader>
														<AlertDialogTitle>
															Are you sure ?
														</AlertDialogTitle>
														<AlertDialogDescription>
															This action cannot be undone. This
															will permanently delete your skill
															category
														</AlertDialogDescription>
													</AlertDialogHeader>
													<AlertDialogFooter>
														<AlertDialogCancel>
															Cancel
														</AlertDialogCancel>
														<AlertDialogAction
															onClick={() =>
																handleDeleteSkill(skill.id)
															}>
															Delete
														</AlertDialogAction>
													</AlertDialogFooter>
												</AlertDialogContent>
											</AlertDialog>
										)}
									</button>
								</TooltipTrigger>
								<TooltipContent>
									<p>Double click to edit</p>
								</TooltipContent>
							</Tooltip>
						</TooltipProvider>
					)}
				</li>
			);
		});

		return (
			<ul className="flex flex-wrap gap-y-1 border-b border-gray-200 mb-10">
				{allSkills}
			</ul>
		);
	};

	const handleSelectSkill = async (skill: any) => {
		setCurrentSkill(skill);
		setEditSkillNameMode(false);
	};

	const Content = () => {
		const [isOpen, setIsOpen] = useState(false);
		const [isEditTags, setIsEditTags] = useState(false);
		const [isEditEducation, setIsEditEducation] = useState(false);
		const [isEditCertification, setIsEditCertification] = useState(false);
		const [isEditAwards, setIsEditAwards] = useState(false);
		const modalRef = useRef<HTMLDialogElement | null>(null);

		const onUpdateSkillCategoryAbout = async (id: string, about: any) => {
			console.log("-----------ARGS RECIEWVED ", about);
			const skillPrevious = skills.find(function (skill: any) {
				return skill.id === id;
			});

			if (!skillPrevious) {
				return;
			}

			const skillUpdated = {
				...skillPrevious!,
				about: about,
			};

			const skillNew = skills.map(function (skill: any) {
				return skill.id === id ? skillUpdated : skill;
			});
			setCurrentSkill(skillUpdated);
			setSkills(skillNew);

			let result;

			const toastId = toast({
				title: "Saving...",
			});

			try {
				const res = await fetch("/api/user/skills/category/about", {
					method: "PUT",
					body: JSON.stringify({
						userId,
						id,
						about: about,
					}),
				});
				result = await res.json();

				toastId.update(
					toast({
						title: "Saved",
					})
				);

				console.log("----RESULT FROM ABOUT UPDATE", result);
			} catch (e: any) {
				toastId.update(
					toast({
						title: "Error",
						description: e.message,
					})
				);
			}
		};

		const onUpdateSkillCategoryEducation = async (
			id: string,
			education: any,
			marker: string
		) => {
			const user = await getUserInfo();

			const skillPrevious = skills.find(function (skill: any) {
				return skill.id === id;
			});

			if (!skillPrevious) {
				return;
			}

			if (marker == "edit") {
				skillPrevious!.education![education.index] = education.education;
			} else {
				skillPrevious!.education!.push(education);
			}

			let result;

			const toastId = toast({
				title: "Saving...",
			});

			try {
				const res = await fetch("/api/user/skills/category/education", {
					method: "PUT",
					body: JSON.stringify({
						userId,
						id,
						education: skillPrevious.education,
					}),
				});
				result = await res.json();

				toastId.update(
					toast({
						title: "Saved",
					})
				);
			} catch (e: any) {
				toastId.update(
					toast({
						title: "Error",
						description: e.message,
					})
				);
			}

			// const result = await toast.promise(
			// 	updateSkillCategoryEducation(userId, id, skillPrevious.education),
			// 	{
			// 		pending: {
			// 			render() {
			// 				return "Saving...";
			// 			},
			// 			icon: false,
			// 		},
			// 		success: {
			// 			render({ data }) {
			// 				return `Saved`;
			// 			},
			// 			// other options
			// 			icon: "🟢",
			// 		},
			// 		error: {
			// 			render({ data }) {
			// 				return data.message;
			// 			},
			// 		},
			// 	}
			// );

			const skillUpdated = {
				...skillPrevious,
				education: result,
			};

			const skillNew = skills.map(function (skill: any) {
				return skill.id === id ? skillUpdated : skill;
			});
			setCurrentSkill(skillUpdated);
			setSkills(skillNew);
		};

		const onUpdateSkillCategoryCertification = async (
			id: string,
			certification: any,
			marker: string
		) => {
			const user = await getUserInfo();

			const skillPrevious = skills.find(function (skill: any) {
				return skill.id === id;
			});

			if (!skillPrevious) {
				return;
			}
			if (marker == "edit") {
				skillPrevious!.certification![certification.index] =
					certification.certification;
			} else {
				skillPrevious!.certification!.push(certification);
			}

			let result;

			const toastId = toast({ title: "Saving", variant: "default" });

			try {
				const res = await fetch("/api/user/skills/category/certification", {
					method: "PUT",
					body: JSON.stringify({
						userId,
						id,
						certifications: skillPrevious.certification,
					}),
				});
				result = await res.json();

				toastId.update(
					toast({
						title: "Saved",
						variant: "default",
					})
				);
			} catch (e: any) {
				toastId.update(
					toast({
						title: "Error",
						description: e.message,
					})
				);
			}

			const skillUpdated: SkillObj = {
				...skillPrevious,
				certification: result,
			};

			const skillNew = skills.map(function (skill: any) {
				return skill.id === id ? skillUpdated : skill;
			});
			setCurrentSkill(skillUpdated);
			setSkills(skillNew);
		};

		const onUpdateSkillCategoryAward = async (
			id: string,
			awards: any,
			marker: string
		) => {
			const user = await getUserInfo();
			const skillPrevious = skills.find(function (skill: any) {
				return skill.id === id;
			});

			if (!skillPrevious) {
				//TODO throw an error or indicate user toast
				return;
			}

			if (marker == "edit") {
				skillPrevious!.awards![awards.index] = awards.award.name;
			} else {
				skillPrevious!.awards!.push(awards.name);
			}

			const mappedList = skillPrevious!.awards!.map((x: any) => ({
				name: x,
			}));

			let result;

			const toastId = toast({
				title: "Saving...",
			});

			try {
				const res = await fetch(`/api/user/skills/category/awards`, {
					method: "PUT",
					body: JSON.stringify({ userId, id, mappedList }),
				});
				result = await res.json();

				toastId.update(
					toast({
						title: "Saved",
						variant: "default",
					})
				);
			} catch (e: any) {
				console.log("THERE WAS AN ERROR In AWARDS ", e);
				toastId.update(
					toast({
						title: "Error",
						description: e.message,
					})
				);
			}

			// const result = await toast.promise(
			// 	updateSkillCategoryAwards(userId, id, mappedList),
			// 	{
			// 		pending: {
			// 			render() {
			// 				return "Saving...";
			// 			},
			// 			icon: false,
			// 		},
			// 		success: {
			// 			render({ data }) {
			// 				return `Saved`;
			// 			},
			// 			// other options
			// 			icon: "🟢",
			// 		},
			// 		error: {
			// 			render({ data }) {
			// 				// When the promise reject, data will contains the error
			// 				return data.message;
			// 			},
			// 		},
			// 	}
			// );

			const skillUpdated = {
				...skillPrevious,
				award: result,
			};

			const skillNew = skills.map(function (skill: any) {
				return skill.id === id ? skillUpdated : skill;
			});
			setCurrentSkill(skillUpdated);
			setSkills(skillNew);
		};

		const onUpdateSkillCategoryTags = (id: string, tags: any) => {
			const skillPrevious = skills.find(function (skill: any) {
				return skill.id === id;
			});

			if (!skillPrevious) {
				return;
			}

			const skillUpdated: SkillObj = {
				...skillPrevious!,
				categories: tags,
			};

			const skillNew = skills.map(function (skill: any) {
				return skill.id === id ? skillUpdated : skill;
			});
			setCurrentSkill(skillUpdated);
			setSkills(skillNew);
		};

		const addCertificate = () => {
			content = (
				<CertificatesForm
					id={currentSkill.id}
					onUpdate={onUpdateSkillCategoryCertification}
				/>
			);
			setIsOpen(true);
		};
		const addAbout = () => {
			content = (
				<AboutForm
					id={currentSkill.id}
					aboutDetails={currentSkill?.about}
					onUpdate={onUpdateSkillCategoryAbout}
				/>
			);
			setIsOpen(true);
		};

		const addAward = () => {
			content = (
				<AwardForm
					id={currentSkill.id}
					onUpdate={onUpdateSkillCategoryAward}
				/>
			);
			setIsOpen(true);
		};

		const addEducation = () => {
			content = (
				<EducationForm
					id={currentSkill.id}
					onUpdate={onUpdateSkillCategoryEducation}
				/>
			);
			setIsOpen(true);
		};
		function isAboutEmpty(skill: SkillObj): boolean {
			return !disable &&
				skill?.name &&
				(!skill?.about?.halfAnHour || !skill?.about?.hour)
				? true
				: false;
		}
		function isEducationEmpty(skill: SkillObj): boolean {
			return !disable && skill?.name && !skill?.education?.length
				? true
				: false;
			// return true
		}
		return (
			<div>
				<div className="col-span-full md:max-w-full mx-auto">
					<Card className="mb-3">
						<CardContent
							className={`p-6 ${
								isAboutEmpty(currentSkill)
									? "border border-rose-600"
									: "border-0"
							}`}>
							<div className="flex justify-between flex-wrap min-[360px]:flex-nowrap">
								<div className="w-11/12">
									<h6 className="mb-0 break-all text-lg font-semibold">
										{isAboutEmpty(currentSkill) ? "* ABOUT" : "ABOUT"}
									</h6>
								</div>
								{!disable && currentSkill.name && (
									<div className=" text-right">
										<Pencil1Icon
											height={undefined}
											width={undefined}
											className="h-6 sm:h-7 cursor-pointer"
											onClick={addAbout}
										/>
									</div>
								)}
							</div>
							<hr className="mb-6" />
							<About about={currentSkill?.about} />
						</CardContent>
					</Card>
				</div>
				<div className="col-span-full md:max-w-full mx-auto">
					<Card className="mb-3">
						<CardContent
							className={`p-6 ${
								isEducationEmpty(currentSkill)
									? "border border-rose-600"
									: "border-0"
							}`}>
							<div className="flex justify-between flex-wrap min-[360px]:flex-nowrap">
								<div className="w-11/12">
									<h6 className="mb-0 break-all text-lg font-semibold">
										{isEducationEmpty(currentSkill)
											? "* EDUCATION"
											: "EDUCATION"}
									</h6>
								</div>
								{!disable && (
									<div className=" text-right">
										<div className="flex justify-between">
											{currentSkill.name && (
												<>
													<PlusCircledIcon
														height={undefined}
														width={undefined}
														className="h-6 sm:h-7 mr-2 cursor-pointer"
														onClick={addEducation}
													/>
													<Pencil1Icon
														height={undefined}
														width={undefined}
														className="h-6 sm:h-7 cursor-pointer"
														onClick={() =>
															setIsEditEducation(true)
														}
													/>
												</>
											)}
										</div>
									</div>
								)}
							</div>
							<hr className="mb-6" />
							<Education
								education={currentSkill?.education}
								isEditEducation={isEditEducation}
								id={currentSkill.id}
								onUpdate={onUpdateSkillCategoryEducation}
							/>
						</CardContent>
					</Card>
				</div>

				<div className="col-span-full md:max-w-full mx-auto">
					<Card className="mb-3">
						<CardContent className="p-6">
							<div className="flex justify-between flex-wrap min-[360px]:flex-nowrap">
								<div className="w-11/12">
									<h6 className="mb-0 break-all text-lg font-semibold">
										CERTIFICATION
									</h6>
								</div>
								{!disable && (
									<div className="text-right">
										<div className="flex justify-between">
											{currentSkill.name && (
												<>
													<PlusCircledIcon
														height={undefined}
														width={undefined}
														className="h-6 sm:h-7 cursor-pointer mr-2"
														onClick={addCertificate}
													/>
													<Pencil1Icon
														height={undefined}
														width={undefined}
														className="h-6 sm:h-7 cursor-pointer "
														onClick={() =>
															setIsEditCertification(true)
														}
													/>
												</>
											)}
										</div>
									</div>
								)}
							</div>
							<hr className="mb-6" />
							<Certificates
								certification={currentSkill?.certification}
								isEditCertification={isEditCertification}
								id={currentSkill.id}
								onUpdate={onUpdateSkillCategoryCertification}
							/>
						</CardContent>
					</Card>
				</div>
				<div className="col-span-full md:max-w-full mx-auto">
					<Card className="mb-3">
						<CardContent className="p-6">
							<div className="flex justify-between flex-wrap min-[360px]:flex-nowrap">
								<div className="w-11/12">
									<h6 className="mb-0 break-all text-lg font-semibold">
										AWARDS
									</h6>
								</div>
								{!disable && (
									<div className=" text-right">
										<div className="flex justify-between">
											{currentSkill.name && (
												<>
													<PlusCircledIcon
														height={undefined}
														width={undefined}
														className="h-6 sm:h-7 cursor-pointer mr-2"
														onClick={addAward}
													/>
													<Pencil1Icon
														height={undefined}
														width={undefined}
														className="h-6 sm:h-7 cursor-pointer "
														onClick={() => setIsEditAwards(true)}
													/>
												</>
											)}
										</div>
									</div>
								)}
							</div>
							<hr className="mb-6" />
							<Award
								awards={currentSkill?.awards}
								isEditAwards={isEditAwards}
								id={currentSkill.id}
								onUpdate={onUpdateSkillCategoryAward}
							/>
						</CardContent>
					</Card>
				</div>
				<div className="col-span-full md:max-w-full mx-auto">
					<Card className="mb-3">
						<CardContent className="p-6">
							<div className="flex justify-between flex-wrap min-[360px]:flex-nowrap">
								<div className="w-11/12">
									<h6 className="mb-0 break-words text-lg font-semibold">
										SUB CATEGORIES
									</h6>
								</div>
								{!disable && currentSkill.name && (
									<div className=" text-right">
										{isEditTags ? (
											<ChevronUpIcon
												height={undefined}
												width={undefined}
												className="h-6 sm:h-7 cursor-pointer "
												onClick={() => setIsEditTags(false)}
											/>
										) : (
											<Pencil1Icon
												height={undefined}
												width={undefined}
												className="h-6 sm:h-7 cursor-pointer "
												onClick={() => setIsEditTags(true)}
											/>
										)}
									</div>
								)}
							</div>
							<hr />
							<Categories
								user={userId}
								setIsEditTags={setIsEditTags}
								isEditTags={isEditTags}
								skill={currentSkill}
								onUpdate={onUpdateSkillCategoryTags}
							/>
						</CardContent>
					</Card>
				</div>
				<Dialog open={isOpen} onOpenChange={setIsOpen}>
					<DialogContent>{content}</DialogContent>
				</Dialog>
			</div>
		);
	};

	console.log("------IS DISABLED ", disable);
	return (
		<>
			<div>
				<div className="main-body center">
					<div className="col-md-12 mx-auto">
						<div className="profile-tabs">
							{!disable ? (
								<div className="inline-flex cursor-pointer">
									{createSkills()}
									{/* <i
										className="bi bi-plus-circle"
										data-toggle="tooltip"
										title="Add New Skills Category"
										onClick={handleAddSkill}
									/> */}
									<PlusCircledIcon
										height={undefined}
										width={undefined}
										className="h-6 mr-3 sm:h-7 cursor-pointer "
										onClick={handleAddSkill}
									/>
									<span className="pt-1">Add New Skill Category</span>
								</div>
							) : (
								<div className="row tab-title">{createSkills()}</div>
							)}
						</div>
					</div>
					<Content />
				</div>
			</div>

			<Dialog open={showModal} onOpenChange={setShowModal}>
				<DialogContent>
					<PayPalScriptProvider
						options={{
							clientId: env.NEXT_PUBLIC_PAYPAL_CLIENT_ID,
							components: "buttons",
							intent: "subscription",
							vault: true,
						}}>
						<img
							src="/images/bazzarroom-logo-small.png"
							alt="bazaar-logo-img"
						/>
						<p className="py-5">
							You&apos;ve reached your skill category limit
							<h6>{limitMessage}</h6>
						</p>
						{tier !== "TeacherPlus" && (
							<PayPalButtons
								createSubscription={(data, actions) => {
									return actions.subscription.create({
										/* Creates the subscription */
										plan_id: env.NEXT_PUBLIC_PLAN_ID_SKILLS_PLUS,
									});
								}}
								onApprove={async (data, actions) => {
									const toastId = toast({ title: "Processing..." });

									try {
										// await initiateProfile(membership, subscriptionId)
										await fetch("/api/user/profile", {
											method: "POST",
											body: JSON.stringify({
												membership: "TeacherPlus",
												subscriptionId: data.subscriptionID!,
											}),
										});
										await fetch("/api/transactions", {
											method: "POST",
											body: JSON.stringify({
												subscriptionId: data.subscriptionID!,
												tier: "TeacherPlus",
											}),
										});

										toastId.update(toast({ title: "Success" }));
										setShowModal(false);
										window.location.href = pathname;
									} catch (e: any) {
										toastId.update(toast({ title: "Failed" }));
									}
								}}
								style={{
									shape: "rect",
									color: "gold",
									layout: "vertical",
									label: "subscribe",
								}}
							/>
						)}
					</PayPalScriptProvider>
				</DialogContent>
			</Dialog>
		</>
	);
};
